/** @file AI view panel registration (spec §9: per-actor feed of renders and contact sheets). */
import type { PanelEntry } from '../panelEntry';
import { AiViewPanel } from './AiViewPanel';

/** Linked from the Activity actor badges (openAiView). */
export const panel: PanelEntry = { id: 'aiView', title: 'aiView.title', bindings: [], component: AiViewPanel };
